/*
  GW size guide on product pages (shoes and belts only).
  - Adds a row under the size buttons: live conversion (e.g. "EU 38 = UK 5 = US 8") + "Size guide" link.
  - "Size guide" opens a drawer (bottom sheet on mobile) with only the relevant table, the selected size highlighted,
    how to measure, brand fit notes and a concierge link.
  - Reads product type / vendor / sizes from /products/<handle>.js, so the product template is not edited.
  Styling: assets/gw-size-guide.css
*/
(function () {
  var PHONE = '19296267207';

  var TABLES = {
    women: {
      title: "Women's shoes",
      cols: ['EU', 'UK', 'US', 'Foot length'],
      key: 0,
      rows: [
        ['35', '2', '5', '22.5 cm'],
        ['36', '3', '6', '23.0 cm'],
        ['37', '4', '7', '23.8 cm'],
        ['38', '5', '8', '24.5 cm'],
        ['39', '6', '9', '25.1 cm'],
        ['40', '7', '10', '25.7 cm'],
        ['41', '8', '11', '26.4 cm']
      ],
      line: function (r) { return 'EU ' + r[0] + ' = UK ' + r[1] + ' = US ' + r[2]; },
      measure: 'Stand on a sheet of paper, mark your heel and longest toe, and measure the distance in cm. Compare it with the foot length column.',
      note: 'Women\'s sizes are listed in European (EU) sizing. Indian sizes follow UK sizing.'
    },
    men: {
      title: "Men's shoes",
      cols: ['UK', 'EU', 'US', 'Foot length'],
      key: 0,
      rows: [
        ['5', '39', '6', '24.4 cm'],
        ['6', '40', '7', '25.1 cm'],
        ['7', '41', '8', '25.7 cm'],
        ['8', '42', '9', '26.4 cm'],
        ['9', '43', '10', '27.0 cm'],
        ['10', '44', '11', '27.7 cm'],
        ['11', '45', '12', '28.3 cm'],
        ['12', '46', '13', '29.0 cm']
      ],
      line: function (r) { return 'UK ' + r[0] + ' = EU ' + r[1] + ' = US ' + r[2]; },
      measure: 'Stand on a sheet of paper, mark your heel and longest toe, and measure the distance in cm. Compare it with the foot length column.',
      note: 'Men\'s sizes are listed in UK sizing. Indian sizes follow UK sizing.'
    },
    belt: {
      title: 'Belts',
      cols: ['Waist (in)', 'Waist (cm)'],
      key: 0,
      rows: [
        ['28', '71'],
        ['30', '76'],
        ['32', '81'],
        ['34', '86'],
        ['36', '91'],
        ['38', '97'],
        ['40', '102'],
        ['42', '107']
      ],
      line: function (r) { return r[0] + ' in = ' + r[1] + ' cm'; },
      measure: 'Lay a belt you own flat and measure from the fold of the buckle to the hole you use most. Or measure your waist where you will wear the belt.',
      note: 'Belt sizes refer to waist size in inches.'
    }
  };

  var FIT_NOTES = {
    'christian louboutin': 'Christian Louboutin tends to run small. We recommend half a size up.'
  };

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function detectKind(type) {
    var t = (type || '').toLowerCase();
    if (t.indexOf('belt') !== -1) return 'belt';
    if (t.indexOf('shoe') !== -1 || t.indexOf('footwear') !== -1) {
      if (t.indexOf('women') !== -1) return 'women';
      if (t.indexOf('men') !== -1) return 'men';
    }
    return null;
  }

  function findPicker() {
    return document.querySelector('variant-radios, variant-selects, variant-picker') ||
      (function () {
        var input = document.querySelector('input[type="radio"][name^="options"], select[name^="options"]');
        return input ? (input.closest('fieldset') || input.parentElement) : null;
      })();
  }

  function selectedValue(picker) {
    if (!picker) return '';
    var checked = picker.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var sel = picker.querySelector('select');
    return sel ? sel.value : '';
  }

  function findRow(table, value) {
    var n = parseFloat(String(value).replace(',', '.'));
    if (isNaN(n)) return null;
    for (var i = 0; i < table.rows.length; i++) {
      if (parseFloat(table.rows[i][table.key]) === n) return table.rows[i];
    }
    return null;
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function buildDrawer(table, product, getSelected) {
    var overlay = el('div', 'gw-sg-overlay');
    var panel = el('aside', 'gw-sg-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Size guide');

    var head = el('div', 'gw-sg-head');
    head.appendChild(el('p', 'gw-sg-eyebrow', 'Size guide'));
    head.appendChild(el('h2', 'gw-sg-title', table.title));
    var close = el('button', 'gw-sg-close', '&times;');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close size guide');
    head.appendChild(close);
    panel.appendChild(head);

    var body = el('div', 'gw-sg-body');
    var tbl = el('table', 'gw-sg-table');
    var thead = '<thead><tr>' + table.cols.map(function (c) { return '<th scope="col">' + c + '</th>'; }).join('') + '</tr></thead>';
    var tbody = '<tbody>' + table.rows.map(function (r) {
      return '<tr data-key="' + r[table.key] + '">' + r.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
    }).join('') + '</tbody>';
    tbl.innerHTML = thead + tbody;
    body.appendChild(tbl);

    body.appendChild(el('p', 'gw-sg-note', table.note));

    var fit = FIT_NOTES[(product.vendor || '').toLowerCase()];
    if (fit) body.appendChild(el('p', 'gw-sg-fit', '<strong>Fit note:</strong> ' + fit));

    var measure = el('div', 'gw-sg-measure');
    measure.appendChild(el('h3', 'gw-sg-subtitle', 'How to measure'));
    measure.appendChild(el('p', null, table.measure));
    body.appendChild(measure);

    var msg = 'Hi Galleria, can you help me with sizing for this piece: ' + window.location.origin + '/products/' + product.handle;
    var ask = el('a', 'gw-sg-ask', 'Unsure of your size? Ask our concierge &rarr;');
    ask.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(msg);
    ask.target = '_blank';
    ask.rel = 'noopener';
    body.appendChild(ask);

    panel.appendChild(body);
    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      var current = getSelected();
      var rows = tbl.querySelectorAll('tbody tr');
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('is-selected', current && parseFloat(rows[i].getAttribute('data-key')) === parseFloat(current));
      }
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
      document.documentElement.classList.add('gw-sg-lock');
      close.focus();
    }
    function shut() {
      overlay.classList.remove('is-open');
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('gw-sg-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    close.addEventListener('click', shut);
    overlay.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) shut();
    });
    return open;
  }

  function init() {
    if (document.querySelector('.gw-sg-row')) return;
    var handle = productHandle();
    if (!handle) return;

    fetch(window.location.origin + '/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.variants || product.variants.length < 2) return;
        var kind = detectKind(product.type);
        if (!kind) return;
        var table = TABLES[kind];
        var picker = findPicker();
        if (!picker) return;

        var row = el('div', 'gw-sg-row');
        var conv = el('span', 'gw-sg-conv', '');
        var link = el('button', 'gw-sg-link', 'Size guide');
        link.type = 'button';
        row.appendChild(conv);
        row.appendChild(link);
        picker.parentNode.insertBefore(row, picker.nextSibling);

        function getSelected() { return selectedValue(picker); }
        function update() {
          var r = findRow(table, getSelected());
          conv.textContent = r ? table.line(r) : '';
        }
        update();
        picker.addEventListener('change', function () { setTimeout(update, 0); });

        var open = buildDrawer(table, product, getSelected);
        link.addEventListener('click', open);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
